// extracted by mini-css-extract-plugin
export default {"description":"style_description__eh1JR","fade-in":"style_fade-in__eHNY8","top":"style_top__Bd+U0","image":"style_image__sgAYn"};